import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHomeFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHomeFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1e5b800a71fa127ae5f43b89c6c6af418c2235af', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '055a1096693a7c85aed9c76b4661dee30e60d98e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'db0309266d9c25b6889427330eec098abed60aea', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.329 9.767a1 1 0 0 0-.329.741v6.986a.51.51 0 0 0 .506.506H8.5a.5.5 0 0 0 .5-.5l.006-5a.5.5 0 0 1 .5-.5h2.988a.505.505 0 0 1 .506.506V17.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-6.992a1 1 0 0 0-.329-.741l-7.338-6.638a.5.5 0 0 0-.666 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-home-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-home-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-home-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHomeFilled$1);
            }
            break;
    } });
}

const CosmosIconHomeFilled = CosmosIconHomeFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHomeFilled, defineCustomElement };
